import React, { Component } from 'react'
import { connect } from 'react-redux';
import NoRowBG from '../../assets/images/icons/bg_nodata.png';
class NoRow extends Component {
  render() {
    const { language, style } = this.props;
    return (
      <div style={style}>
        <img src={NoRowBG} alt='no_row_bg' />
        <h3 style={{ textAlign: 'center' }}>{language.common_no_data}</h3>
      </div>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(NoRow)